export const RESULT_TYPES = {
  APP_LISTING: 'APP_LISTING',
  BLOG_POST: 'BLOG_POST',
  CALL: 'CALL',
  CAMPAIGN: 'CAMPAIGN',
  COMPANY: 'COMPANY',
  CONTACT: 'CONTACT',
  CRM_EMAIL: 'CRM_EMAIL',
  CUSTOM_OBJECT: 'CUSTOM_OBJECT',
  DASHBOARD: 'DASHBOARD',
  DEAL: 'DEAL',
  EMAIL: 'EMAIL',
  KNOWLEDGE_DOC: 'KNOWLEDGE_DOC',
  LANDING_PAGE: 'LANDING_PAGE',
  LIST: 'LIST',
  MEETING: 'MEETING',
  NAVIGATION: 'NAVIGATION',
  NOTE: 'NOTE',
  SETTINGS: 'SETTINGS',
  SITE_PAGE: 'SITE_PAGE',
  TASK: 'TASK',
  TICKET: 'TICKET',
  WORKFLOW: 'WORKFLOW',
  ACADEMY: 'ACADEMY'
};
export function isResultType(value) {
  return value in RESULT_TYPES;
}